import React from "react";

import { ModalConfirmation, toast } from "@performyard/py-components";

import { useManuallyCloseEngagementSurvey } from "../../../../../../api/hooks/defs/engagement";

type CloseSurveyModalProps = {
	isOpen: boolean;
	handleClose: () => void;
	triggerRefetch: () => void;
};

const CloseSurveyModal = ({ isOpen, handleClose, triggerRefetch }: CloseSurveyModalProps) => {
	const { mutate: manuallyCloseEngagementSurvey, isPending: isManuallyClosingEngagementSurvey } =
		useManuallyCloseEngagementSurvey({
			meta: {
				disableDefaultErrorHandling: true,
			},
			onSuccess: () => {
				toast.success("Pulse survey manually closed");
				triggerRefetch();
				handleClose();
			},
			onError: () => {
				toast.error("Failed to close pulse survey");
			},
		});

	return (
		<ModalConfirmation
			isOpen={isOpen}
			onClose={handleClose}
			dangerouslySetClassName="w-[432px]"
			title="Close Current Pulse?"
			subtitle="Are you sure you want to close the current pulse survey? Once Closed, no further responses will be collected."
			negativeButtonProps={{
				children: "Cancel",
				onClick: handleClose,
				color: "neutral",
				size: "large",
				type: "button",
				variant: "outline",
			}}
			positiveButtonProps={{
				children: "Yes, Close",
				onClick: manuallyCloseEngagementSurvey,
				disabled: isManuallyClosingEngagementSurvey,
				color: "green",
				size: "large",
				type: "button",
				disabled: isManuallyClosingEngagementSurvey,
			}}
		/>
	);
};

export default CloseSurveyModal;
